var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudWideDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 32,
    viewBox: "0 0 80 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.30078,
    y: 0.5,
    width: 77.6,
    height: 31,
    rx: 3.5,
    fill: "#121B18"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.30078,
    y: 0.5,
    width: 77.6,
    height: 31,
    rx: 3.5,
    stroke: "#333333"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_992_40263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1003 20.0028H36.5383C34.8236 20.0001 33.4336 18.6621 33.4336 17.0114C33.4336 15.3614 34.8236 14.0234 36.5383 14.0234C36.8003 12.8488 37.7343 11.8901 38.9883 11.5081C40.2416 11.1268 41.6256 11.3794 42.6176 12.1748C43.6096 12.9681 44.0589 14.1794 43.7976 15.3541H44.4576C45.3776 15.3541 46.1729 15.8961 46.5443 16.6808M44.7669 18.6668V22.6668M44.7669 22.6668L46.7669 20.6668M44.7669 22.6668L42.7669 20.6668",
    stroke: "#00FFE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_992_40263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(32.1016 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudWideDark);
export default __webpack_public_path__ + "static/media/cloudWideDark.e4f59ac28d562bda29e8ca682d91ec4b.svg";
export { ForwardRef as ReactComponent };